namespace advisorop.components.advisor {

    export class NewCuAccountController {

        // input params
        //account: domains.IAccount = { id: 0, manualAccount: {}, investors: [], holdingsMaintaindExSystem: true };
        createNewCustodianAccount: boolean = false;
        investorsDirty: boolean = false;
        //advisoryFirm: domains.IAdvisoryFirm;
        appInitialized: boolean = false;
        iAmReady: any;
        readyDone: boolean = false;
        formDataChanged: any;
        onOrionAccountSelected: any;
        //advisorIsDone: any;
        doingBinding: boolean = false;

        // user info
        user: domains.identity.IUser;
        impersonatedByServicer: boolean = false;

        // dropdowns
        advisoryFirms: Array<domains.IAdvisoryFirm> = [];
        custodians: domains.ICustodianAdvisoryFirm[] = [];
        householdGroups: domains.IHousehold[] = [];
        lovs: Array<domains.ILOV> = [];
        titleTypes: Array<domains.ILOV> = [];
        titleSubtypes: Array<domains.ILOV> = [];
        accountTypes: Array<domains.ILOV> = [];
        tamps: domains.ITamp[] = [];
        //productTypes: domains.ILOV[] = [];
        //managers: domains.IManager[] = [];
        //products: domains.IManagerProduct[] = [];
        //insuranceTypes: Array<domains.ILOV> = [];
        //insuranceSubtypes: Array<domains.ILOV> = [];
        //premiumModels: Array<domains.ILOV> = [];
        //generalInvestmentAccountTypes: Array<domains.ILOV> = [];
        //states: Array<domains.ILOV> = [];

        selTitleType: domains.ILOV;
        selTitleSubtype: domains.ILOV;
        selAccountType: domains.ILOV = null;
        selTamp: domains.ITamp;
        //selProductType: domains.ILOV;
        //selManager: domains.IManager;
        //selProduct: domains.IManagerProduct;
        selHouseholdGroup: domains.IHousehold;
        selAdvisoryFirm: domains.IAdvisoryFirm;
        //selPremiumModel: domains.ILOV;
        //selPolicyType: domains.ILOV;
        //selPolicySubtype: domains.ILOV;
        //selGeneralInvestmentAccountType: domains.ILOV;
        //selState: domains.ILOV;

        companyGroup: domains.ICompanyGroup;
        //currentAdvisor: domains.IAdvisor;

        //insuranceType: number = domains.ManualAccountHoldingType.INSURANCE;
        //hasInsuranceSubtypes: boolean = false;


        //loveTypeOfSubtypes: number;

        //showGeneralAccountTypeField: boolean = false;
        //showStateField: boolean = false;

        hasRtgHoldings: boolean = false;

        investorType: domains.InvestorType = null;
        entityType: domains.EntityType = null;

        // types 
        accountType = domains.InvestmentType;
        //productType = domains.ProductType;
        titleType = domains.TitleType;

        isWorking: boolean = false;
        selSetupCode: domains.AccountCreationType;
        selAdvisoryFirmMgtRole?: domains.AdvisoryFirmMgtRole;
        dateDocsNeeded: Date;
        selDocDeliveryMethod: domains.DocumentDeliveryMethod;
        setupCode_New: number = domains.AccountCreationType.NEW_ACCOUNT;
        setupCode_AddExisting: number = domains.AccountCreationType.ADD_TO_EXISTING_ACCOUNT;
        setupCode_CopyExisting: number = domains.AccountCreationType.COPY_FROM_EXISTING_ACCOUNT;
        public sourceAccountForCopy: domains.ISearchAccountResults = null;
        public sourceAccountForAdd: domains.ISearchAccountResults = null;
        relAccountNumber: string = "";
        relAccountName: string = "";

        accountCreationShortcuts: domains.IAccountCreationShortcut[] = [];
        selAccountCreationShortcut: domains.IAccountCreationShortcut;

        accountType_OutsideInvestment: number = domains.InvestmentType.OUTSIDE_INVESTMENT;
        accountType_DirectInvestment: number = domains.InvestmentType.DIRECT_INVESTMENT;
        accountType_ManagedModels: number = domains.InvestmentType.MANAGED_MODELS;
        accountType_SMA: number = domains.InvestmentType.SMA;
        accountType_CustodianAccount: number = domains.InvestmentType.CUSTODIAN_ACCOUNT;

        // Orion Account Selection
        orionAccounts: Array<any> = [];
        public selOrionAccount: any = null;
        dgOrionAccounts: DevExpress.ui.dxDataGridOptions;
        loadingOrionAccounts: boolean = false;
        showOrionAccountGrid: boolean = true;
        showOrionAccountPanel: boolean = false;

        selDocumentType_ClientProfile: boolean = false;
        selDocumentType_CheckInstructions: boolean = false;
        selDocumentType_ClientAgreement: boolean = false;
        selDocumentType_ACHForm: boolean = false;
        selDocumentType_RTQ: boolean = false;
        selDocumentType_WireInstructions: boolean = false;
        selDocumentType_PlanningInvoice: boolean = false;
        selDocumentType_TOAForm: boolean = false;

        titleType_CustodialAccount: number = domains.TitleType.CUSTODIAL;

        showHelper: boolean = false;
        noColor: string = "white";
        completeColor: string = "lightgreen";
        incompleteColor: string = "yellow";
        actionStatusColor: string = this.incompleteColor;
        accountStatusColor: string = this.incompleteColor;
        investorsStatusColor: string = this.incompleteColor;
        documentsStatusColor: string = this.completeColor;
        notesStatusColor: string = this.completeColor;

        actionInformationComplete: boolean = false;
        accountInformationComplete: boolean = false;
        investorsInformationComplete: boolean = false;
        basicInformationComplete: boolean = false;
        saveAllInformationToThisPointTooltipIsOpen: boolean = false;
        documentsInformationComplete: boolean = true;
        notesInformationComplete: boolean = true;

        updatingAccountLadda: boolean = false;

        showActionPanel: boolean = true;
        showAccountPanel: boolean = true;
        showInvestorsPanel: boolean = true;
        showDocumentsPanel: boolean = true;
        showNotesPanel: boolean = true;

        //basicSetupDirty: boolean = false;
        orionAccountTypeToTitleTypeMap: { [key: string]: number } = {
            "529": domains.TitleType._529_PLAN_ACCOUNT,
            "401(K)": domains.TitleType.OTHER_RETIREMENT,
            "403(B)": domains.TitleType.OTHER_RETIREMENT,
            "Beneficiary IRA": domains.TitleType.IRA,
            "Community Property": domains.TitleType.JOINT_TENANT,
            "Contributory IRA": domains.TitleType.IRA,
            "Corporation": domains.TitleType.CORPORATION,
            "Custodial": domains.TitleType.CUSTODIAL,
            "Estate": domains.TitleType.ESTATE,
            "Individual": domains.TitleType.INDIVIDUAL,
            "Individual Retirement Account": domains.TitleType.IRA,
            "Inherited IRA": domains.TitleType.IRA,
            "IRA Rollover": domains.TitleType.IRA,
            "Joint": domains.TitleType.JOINT_TENANT,
            "Joint Tenant": domains.TitleType.JOINT_TENANT,
            "JTWROS": domains.TitleType.JOINT_TENANT,
            "Keogh": domains.TitleType.OTHER_RETIREMENT,
            "Non-Profit": domains.TitleType.NON_PROFIT_ORGANIZATION,
            "Partnership": domains.TitleType.PARTNERSHIP,
            "Roth": domains.TitleType.IRA,
            "SEP IRA": domains.TitleType.IRA,
            "Simple": domains.TitleType.IRA,
            "Simplified Employee Pension Plan": domains.TitleType.OTHER_RETIREMENT,
            "Trust": domains.TitleType.TRUST
        };

        workingOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#actionPanelBody" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Working...",
            bindingOptions: {
                visible: "vm.isWorking"
            },
            onShown: function () {
                //setTimeout(function () {
                //    $scope.$apply(function () {
                //        $scope.loadingVisible = false;
                //    });
                //}, 3000);
            },
            onHidden: function () {
                //$scope.employeeInfo = employee;
            }
        };

        static $inject = ["generalService", "advisorService", "identityService", "advisoryFirmApi", "$scope", "$rootScope", "accountApi", "servicerService"];
        constructor(private generalService: services.GeneralService,
            private advisorService: services.AdvisorService,
            private identityService: services.IdentityService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private $scope: ng.IScope,
            private $rootScope: ng.IRootScopeService,
            public accountApi: services.AccountApi,
            private servicerService: advisorop.services.ServicerService) {

            // watch TitleType and TitleSubType
            //$scope.$watchGroup(["vm.account.titleType", "vm.account.titleSubtype", "vm.selTitleType.value", "vm.selTitleSubtype.value"],
            //$scope.$watchGroup(["vm.selTitleType.value", "vm.selTitleSubtype.value"],
            //    (newval: any, oldval: any, scope: ng.IScope) => this.setInvestorsDomain());

            // default advisory firm to first in list if we are not already working with an account

            $scope.$watch("vm.dateDocsNeeded", () => {
                if (!this.doingBinding) {
                    //console.log("WE ARE NOT DOING BINDING...");
                    this.accountDocumentsChanged(true)
                }
            });
            $scope.$watch("vm.accountApi.paccount.id", () => {
                if (this.accountApi.paccount) {
                    //console.log("New-Cu-Account: ACCOUNT ID HAS CHANGED to", this.accountApi.paccount.id);
                    if (this.accountApi.paccount.id > 0) {
                        //console.log("CAUGHT CHANGE IN ACCOUNT!!!!!!! +_+_+__++_+_++_+_+_++_+_+__+__+_++_+_+_+_")
                        this.bindWhenInitialized();
                    }
                }
            });
            $scope.$watch("vm.accountApi.accountWizEditing", () => {
                console.log("New-Cu-Account: ACCOUNT WIZ EDITING FLAG HAS CHANGED to", this.accountApi.accountWizEditing);
                var that = this;
                this.loadAdvisoryFirms().then(response => {
                    // If we are creating a new account, default the advisory firm to the first firm in the list
                    if (that.accountApi.accountWizEditing == false) {
                        that.selAdvisoryFirm = that.advisoryFirms[0];
                        that.advisoryFirmChanged(false);
                        // Set default setup code to NEW_ACCOUNT
                        that.selSetupCode = domains.AccountCreationType.NEW_ACCOUNT;
                        this.onChangeSetupCode();
                        // Initialize Orion DataGrid
                        that.initializeOrionDataGrid();
                        // Load Orion accounts
                        that.loadOrionAccounts();
                    }
                    that.loadLovs();
                    //this.iAmReady({ ctrl: this });
                });
            });
            // reload custodians when firm change
            //this.$scope.$watch("vm.accountApi.paccount.advisoryFirmId", () => {
            //    if (this.accountApi.paccount.advisoryFirmId > 0) {
            //        this.loadCustodians(this.accountApi.paccount.advisoryFirmId);
            //    } else {
            //        this.custodians = [];
            //    }
            //});
            //$scope.$watch("vm.appInitialized", () => {
            //    if (this.appInitialized == true) {
            //        if (!this.readyDone) {
            //            this.readyDone = true;
            //            this.iAmReady({ ctrl: this });
            //        }
            //        //this.bindAccountForm();
            //    }
            //});
            $scope.$watch("vm.sourceAccountForCopy.accountId", () => {
                this.onChangeSourceAccountForCopy();
            });
            $scope.$watch("vm.sourceAccountForAdd.accountId", () => {
                this.onChangeSourceAccountForAdd();
            });
        }

        bindWhenInitialized(): void {
            if (this.appInitialized == true) {
                //console.log("BINDING ACCOUNT FORM!!!!!*$*$*$*$*$*$*$*$*$*$*$*$*$*$*$*$*$*");
                this.bindAccountForm()
                this.iAmReady({ ctrl: this });
            } else {
                //console.log("APPINIT IS FALSE!!!!!!!!!!!!!!!!!!!!");
                let that = this;
                setTimeout(function () { that.bindWhenInitialized() }, 250);
            }
        }

        bindOrionAccount(account: any): void {
            // used by parent controller to set the selected Orion account
            // do not do anything else here, just set the selected account and call the callback
            console.log("BIND ORION ACCOUNT CALLED WITH:", account, "showOrionAccountPanel", this.showOrionAccountPanel, "selSetupCode", this.selSetupCode);
            this.selOrionAccount = account;
            if (this.onOrionAccountSelected) {
                this.onOrionAccountSelected({ orionAccount: account });
            }
        }

    expandAll(): void {
            this.showActionPanel = true;
            this.showAccountPanel = true;
            this.showInvestorsPanel = true;
            this.showDocumentsPanel = true;
            this.showNotesPanel = true;
        }

        collapseCompleted(): void {
            if (this.actionInformationComplete) {
                this.showActionPanel = false;
            }
            if (this.accountInformationComplete) {
                this.showAccountPanel = false;
            }
            if (this.investorsInformationComplete) {
                this.showInvestorsPanel = false;
            }
            if (this.documentsInformationComplete) {
                this.showDocumentsPanel = false;
            }
            if (this.notesInformationComplete) {
                this.showNotesPanel = false;
            }
        }

        collapseAll(): void {
            this.showActionPanel = false;
            this.showAccountPanel = false;
            this.showInvestorsPanel = false;
            this.showDocumentsPanel = false;
            this.showNotesPanel = false;
        }

        toggleActionPanel(): void {
            this.showActionPanel = !this.showActionPanel;
        }
        toggleAccountPanel(): void {
            this.showAccountPanel = !this.showAccountPanel;
        }
        toggleInvestorsPanel(): void {
            this.showInvestorsPanel = !this.showInvestorsPanel;
        }
        toggleDocumentsPanel(): void {
            this.showDocumentsPanel = !this.showDocumentsPanel;
        }
        toggleNotesPanel(): void {
            this.showNotesPanel = !this.showNotesPanel;
        }

        // /////////////////////////////////////
        // account methods
        setInvestorsDomain(): void {
            //if (!this.selTitleType)
            //    return;

            // Nov 2018 GL : commented this out, not sure why 401k specifically was looking for companies,
            // think it can follow the other types and use the same ".extra1" attribute from the LOV entry.
            //if (this.selTitleType.value == domains.TitleType.OTHER_RETIREMENT && this.selTitleSubtype && this.selTitleSubtype.value == domains.TitleSubtype.I401_K) {
            //    if (this.investorType != domains.InvestorType.INDIVIDUAL) {
            //        this.account.investors = [];
            //        this.investorsDirty = true;
            //    }
            //    this.investorType = domains.InvestorType.COMPANY;
            //    this.entityType = null;

            // Entities
            //} else

            //if(this.selTitleType.extra1 == "1") {
            //    if (this.investorType != domains.InvestorType.COMPANY && this.entityType != <domains.EntityType>this.selTitleType.value) {
            //        this.account.investors = [];
            //        this.investorsDirty = true;
            //    }
            //    this.investorType = domains.InvestorType.COMPANY;
            //    this.entityType = <domains.EntityType>this.selTitleType.value;
            //    // Individuals
            //} else if (this.selTitleType.extra1 == "0") {
            //    if (this.investorType != domains.InvestorType.INDIVIDUAL) {
            //        this.account.investors = [];
            //        this.investorsDirty = true;
            //    }
            //    this.investorType = domains.InvestorType.INDIVIDUAL;
            //    this.entityType = null;
            //    //Can be both
            //} else {
            //    this.investorType = null;
            //    this.entityType = null;
            //}
        }

        // User is changing the account they are searching for (account to replicate), so null out the
        // current source account for copy
        addAccountChanged() {
            //console.log("IN ADDACCOUNTCHANGED!!!");
            this.sourceAccountForAdd = null;
            this.accountApi.paccount.setupRelatedAccountId = null;
            this.thisFormDataChanged("sourceAccountAddSearch", true);
        }

        // User is changing the account they are searching for (account to replicate), so null out the
        // current source account for copy
        sourceAccountChanged() {
            //console.log("IN SOURCEACCOUNTCHANGED!!!");
            this.sourceAccountForCopy = null;
            this.accountApi.paccount.setupRelatedAccountId = null;
            this.thisFormDataChanged("sourceAccountCopySearch", true);
        }

        thisFormDataChanged(element: string, changedByUserOnUI: boolean = false) {
            //console.log("In CuAccount:thisFormDataChanged based on", element);
            // Here we are detecting every change on the initial Account form,
            // to determine when the initial account details can be saved.

            if (element == "sourceAccountAddSearch" || element == "sourceAccountCopySearch") {
                this.actionInformationComplete = false;
            } else {
                this.actionInformationComplete = this.actionFieldsComplete();
                this.accountInformationComplete = this.accountFieldsComplete();
                this.investorsInformationComplete = this.investorFieldsComplete();
            }

            if (this.actionInformationComplete) {
                this.actionStatusColor = this.completeColor;
            } else {
                this.actionStatusColor = this.incompleteColor;
                this.showActionPanel = true;
            }

            if (this.accountInformationComplete) {
                this.accountStatusColor = this.completeColor;
            } else {
                this.accountStatusColor = this.incompleteColor;
                this.showAccountPanel = true;
            }

            if (this.investorsInformationComplete) {
                this.investorsStatusColor = this.completeColor;
            } else {
                this.investorsStatusColor = this.incompleteColor;
                this.showInvestorsPanel = true;
            } 

            this.basicInformationComplete = (this.actionInformationComplete == true && this.accountInformationComplete == true && this.investorsInformationComplete == true)

            //console.log("accountInformationComplete:", this.accountInformationComplete);

            // callback to calling controller
            this.formDataChanged({ element: element });

            // Something has changed, mark as dirty
            if (changedByUserOnUI) {
                this.accountApi.basicSetupDirty = true;
                //console.log("BASIC SETUP DIRTY IS TRUE");
            }
        }

        // Check account fields
        actionFieldsComplete(): boolean {
            if (!this.selSetupCode ||
                (this.accountApi.paccount.setupCreationType == domains.AccountCreationType.NEW_ACCOUNT && this.selAccountCreationShortcut == null) ||
                (this.accountApi.paccount.setupCreationType == domains.AccountCreationType.ADD_TO_EXISTING_ACCOUNT && this.accountApi.paccount.setupRelatedAccountId == null) ||
                (this.accountApi.paccount.setupCreationType == domains.AccountCreationType.COPY_FROM_EXISTING_ACCOUNT && this.accountApi.paccount.setupRelatedAccountId == null)) {
                //console.log("ACTION FIELDS ARE INCOMPLETE")
                return false;
            } else {
                //console.log("ACTION FIELDS ARE GOOD")
                return true;
            }
        }

        // Check account fields
        accountFieldsComplete(): boolean {
            if (this.selAdvisoryFirm
                && (this.accountApi.paccount.name != null && this.accountApi.paccount.name.length > 0)
                && this.selTitleType
                && ((!this.titleSubtypes || this.titleSubtypes.length == 0)
                    || (this.titleSubtypes && this.titleSubtypes.length > 0 && this.selTitleSubtype))
                && this.selAccountType
                && ((this.selAccountType.value != this.accountType_ManagedModels && this.selAccountType.value != this.accountType_SMA) || this.selTamp)
                && (this.selAdvisoryFirmMgtRole!= null && this.selAdvisoryFirmMgtRole != undefined)) {
                //console.log("ACCOUNT FIELDS ARE GOOD")
                return true;
            } else { 
                //console.log("ACCOUNT FIELDS ARE INCOMPLETE")
                return false;
            }
        }

        // check investor fields
        investorFieldsComplete(): boolean {
            if (this.accountApi.paccount.investors.length > 0 &&
                this.checkOutsideAccountHH() &&
                this.checkCustodialAcctInvestors() &&
                this.checkJointAcctInvestors()) {
                //console.log("INVESTOR FIELDS ARE GOOD")
                return true;
            } else {
                //console.log("INVESTOR FIELDS ARE INCOMPLETE")
                return false;
            }
        }

        removeInvestor(inv: domains.IInvestor): void {
            var ind = this.accountApi.paccount.investors.indexOf(inv);
            if (ind >= 0) {
                this.accountApi.paccount.investors.splice(ind, 1);
                this.loadHouseholdGroups();
                this.investorsDirty = true;
                this.thisFormDataChanged("investorList", true);
            }
        };

        resetFormFields(): void {
            this.accountApi.paccount.manualAccount = {};
        }

        validateAccountBasicInformationForm(showMessage: boolean = true): boolean {
            let formIsValid = this.generalService.validateForm(<ng.IFormController>this.$scope["accountForm"]);

            if (this.accountApi.paccount.investors.length <= 0) {
                formIsValid = false;
                if (showMessage) {
                    toastr.error("You must select one or more investors.");
                }
            }

            if (!formIsValid && showMessage) {
                toastr.error("Account application is not complete. Please correct errors and try again.");
            }

            return formIsValid;
        };

        createAccount(): ng.IPromise<boolean> {

            this.updatingAccountLadda = true;
            // console.log("Creating new account", JSON.stringify(this.accountApi.paccount));
            //open account ...
            this.accountApi.paccount.titleId = 0;//this.title.id;
            this.accountApi.paccount.titleName = "";//this.title.name;
            this.accountApi.paccount.usdMarketValue = 0;
            this.accountApi.paccount.status = 0;
            this.accountApi.paccount.id = 0;

            //this.bindAccountFromForm();

            //console.log("Account bound from form pre-save: ", this.accountApi.paccount);

            //if (this.selectedSkippOption) {
            //    //this.account.proposal.proposalState = 5;
            //    this.accountApi.paccount.proposal.proposalState = domains.ProposalState.SIGNED;
            //    this.accountApi.paccount.status = 2;
            //}

            //this.getProposalStepTitle();

            return this.advisorService.openAccount(this.accountApi.paccount)
                .then(data => {
                    this.accountApi.paccount = data.data;
                    //if (this.selAdvisoryFirm.firmType > domains.FirmType.REGISTERED_INVESTMENT_ADVISOR)
                    //    this.loadRTQs(this.accountApi.paccount.titleId);
                    //console.log("Account after OPEN CALL: ", this.accountApi.paccount);
                    if (this.impersonatedByServicer == false) {
                        //if (this.accountApi.paccount.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT) {
                        //    toastr.success("Account has been added to the queue and is ready for the Service Team to take over account opening.");
                        //    this.updatingAccountLadda = false;
                        //    this.advisorIsDone();
                        //} else {
                            toastr.success("Account has been successfully initialized. Please complete any additional fields that are known at this time and press Submit.");
                        //}
                    } else {
                        toastr.success("Account has been successfully initialized. Please continue.");
                    }
                    return true;
                }, err => {
                    toastr.error("Account has not been created. Error " + err.data);
                    return false;
                })
                .finally(() => {
                    this.updatingAccountLadda = false;
                });
        };

        updateAccount(): ng.IPromise<boolean> {

            this.updatingAccountLadda = true;

            //this.bindAccountFromForm();

            //if (this.selCustodian)
            //    this.accountApi.paccount.custodianId = this.selCustodian.custodianId;
            //else
            //    this.accountApi.paccount.custodianId = null;

            //if (this.selPricingType)
            //    this.accountApi.paccount.pricingType = this.selPricingType.value;
            //else
            //    this.accountApi.paccount.pricingType = null;

            //if (this.createNewCustodianAccount)
            //    this.accountApi.paccount.isNewCustodianAccount = true;
            //else
            //    this.accountApi.paccount.isNewCustodianAccount = false;

            // If this account is linked to a custodian account, and we are not creating the custodian account at this time,
            // then we need to un - link the account, because the user has changed the investors on this account.
            // Investors need to be the same between the account and custodian account that it is linked to.
            // This unlinks the accounts and resets various form fields.
            //if (this.investorsDirty == true && this.createNewCustodianAccount == false) {
            //    this.resetCustodianAccountData();
            //    this.investorsDirty = false;
            //}

            return this.advisorService.updateAccount(this.accountApi.paccount)
                .then(response => {
                    if (this.impersonatedByServicer == false) {
                        toastr.success("Account has been successfully updated. Please complete any additional fields that are known at this time and press Submit.");
                    } else {
                        toastr.success("Account has been successfully updated.");
                    }
                    this.accountApi.paccount = response.data;
                    //console.log("Account after UPDATE CALL: ", this.accountApi.paccount);
                    //console.log("Account after update: ", this.accountApi.paccount);
                    // If we have a linked custodian account then we may have changed custodian account
                    // details when saving the account... so we will reload the custodian account.
                    // At this time we do not need to re-bind the custodian account to the screen because
                    // none of those details are ones that we would change in this situation.
                    if (this.accountApi.paccount.custodianAccountId > 0) {
                        this.accountApi.getById(this.accountApi.paccount.custodianAccountId)
                            .then(data => {
                                this.accountApi.pcustodianAccount = data.data;
                            });
                    }
                    return true;
                }, err => this.generalService.showError(err))
                .finally(() => this.updatingAccountLadda = false);
        };

        saveAccount(): void {

            //console.log("this.selDocumentType_ACHForm:", this.selDocumentType_ACHForm);
            //console.log("this.selDocumentType_CheckInstructions:", this.selDocumentType_CheckInstructions);
            //console.log("this.selDocumentType_ClientAgreement:", this.selDocumentType_ClientAgreement);
            //console.log("this.selDocumentType_ClientProfile:", this.selDocumentType_ClientProfile);
            //console.log("this.selDocumentType_PlanningInvoice:", this.selDocumentType_PlanningInvoice);
            //console.log("this.selDocumentType_RTQ:", this.selDocumentType_RTQ);
            //console.log("this.selDocumentType_TOAForm:", this.selDocumentType_TOAForm);
            //console.log("this.selDocumentType_WireInstructions:", this.selDocumentType_WireInstructions);

            // Attach the document requests - we will send a new array each time, server will delete all old and rewrite all new
            this.accountApi.paccount.docRequests = [];

            this.saveAllInformationToThisPointTooltipIsOpen = false;
            if (this.selDocumentType_ACHForm) {
                var docReq: domains.IAccountDocRequest = { id: 0, accountId: this.accountApi.paccount.id, documentType: domains.DocumentType.ACH_FORM, dateNeeded: this.dateDocsNeeded, deliveryMethod: this.selDocDeliveryMethod };
                this.accountApi.paccount.docRequests.push(docReq);
            }
            if (this.selDocumentType_CheckInstructions) {
                var docReq: domains.IAccountDocRequest = { id: 0, accountId: this.accountApi.paccount.id, documentType: domains.DocumentType.CHECK_INSTRUCTIONS, dateNeeded: this.dateDocsNeeded, deliveryMethod: this.selDocDeliveryMethod };
                this.accountApi.paccount.docRequests.push(docReq);
            }
            if (this.selDocumentType_ClientAgreement) {
                var docReq: domains.IAccountDocRequest = { id: 0, accountId: this.accountApi.paccount.id, documentType: domains.DocumentType.CLIENT_AGREEMENT, dateNeeded: this.dateDocsNeeded, deliveryMethod: this.selDocDeliveryMethod };
                this.accountApi.paccount.docRequests.push(docReq);
            }
            if (this.selDocumentType_ClientProfile) {
                var docReq: domains.IAccountDocRequest = { id: 0, accountId: this.accountApi.paccount.id, documentType: domains.DocumentType.CLIENT_PROFILE, dateNeeded: this.dateDocsNeeded, deliveryMethod: this.selDocDeliveryMethod };
                this.accountApi.paccount.docRequests.push(docReq);
            }
            if (this.selDocumentType_PlanningInvoice) {
                var docReq: domains.IAccountDocRequest = { id: 0, accountId: this.accountApi.paccount.id, documentType: domains.DocumentType.CLIENT_PLANNING_INVOICE, dateNeeded: this.dateDocsNeeded, deliveryMethod: this.selDocDeliveryMethod };
                this.accountApi.paccount.docRequests.push(docReq);
            }
            if (this.selDocumentType_RTQ) {
                var docReq: domains.IAccountDocRequest = { id: 0, accountId: this.accountApi.paccount.id, documentType: domains.DocumentType.RISK_TOLERANCE_QUESTIONNAIRE, dateNeeded: this.dateDocsNeeded, deliveryMethod: this.selDocDeliveryMethod };
                this.accountApi.paccount.docRequests.push(docReq);
            }
            if (this.selDocumentType_TOAForm) {
                var docReq: domains.IAccountDocRequest = { id: 0, accountId: this.accountApi.paccount.id, documentType: domains.DocumentType.ASSET_TRANSFER, dateNeeded: this.dateDocsNeeded, deliveryMethod: this.selDocDeliveryMethod };
                this.accountApi.paccount.docRequests.push(docReq);
            }
            if (this.selDocumentType_WireInstructions) {
                var docReq: domains.IAccountDocRequest = { id: 0, accountId: this.accountApi.paccount.id, documentType: domains.DocumentType.WIRE_INSTRUCTIONS, dateNeeded: this.dateDocsNeeded, deliveryMethod: this.selDocDeliveryMethod };
                this.accountApi.paccount.docRequests.push(docReq);
            }
            //console.log("this.accountApi.paccount.docRequests:", this.accountApi.paccount.docRequests);


            this.custodians.forEach((item, index) => {
                const acShortcut: domains.IAccountCreationShortcut = {
                    shortcutType: domains.AccountCreationShortcutType.CUSTODIAN,
                    shortcutId: item.custodian.id,
                    description: item.custodian.name
                };
                this.accountCreationShortcuts.push(acShortcut);
            });
            
            if (this.accountApi.paccount.id == 0) {
                this.createAccount().then(success => {
                    if (success) {
                        this.accountApi.basicSetupDirty = false;
                        //console.log("BASIC SETUP DIRTY IS FALSE");
                    };
                });
            } else {
                this.updateAccount().then(success => {
                    if (success) {
                        this.bindAccountForm();
                    };
                });
            }
        }


        // ////////////////////////////////
        // on change methods
        onChangeSetupCode(): void {
            //console.log("In onChangeSetupCode");
            //console.log("Setup code changed to", this.selSetupCode);
            this.accountApi.paccount.setupCreationType = this.selSetupCode;
            this.thisFormDataChanged("setupCode", true);
            this.selAccountCreationShortcut = null;
            this.acShortcutChanged(false);
            this.sourceAccountForAdd = null;
            this.onChangeSourceAccountForAdd();
            this.sourceAccountForCopy = null;
            this.onChangeSourceAccountForCopy();
            
            // Handle Orion account selection for NEW_ACCOUNT
            if (this.selSetupCode === domains.AccountCreationType.NEW_ACCOUNT) {
                this.initializeOrionDataGrid();
                this.loadOrionAccounts();
                this.showOrionAccountGrid = true;
                this.showOrionAccountPanel = false;
            } else {
                this.showOrionAccountGrid = false;
                this.showOrionAccountPanel = false;
                this.selOrionAccount = null;
            }
            
            return;
        }

        // Orion Account Selection Methods
        initializeOrionDataGrid(): void {
            this.dgOrionAccounts = {
                export: {
                    enabled: false
                },
                bindingOptions: {
                    dataSource: "vm.orionAccounts"
                },
                scrolling: {
                    mode: "standard"
                },
                paging: {
                    pageSize: 10,
                    enabled: true
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                showColumnHeaders: true,
                columnAutoWidth: true,
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "representative", caption: "Advisor", width: 120 },
                    { dataField: "number", caption: "Account Number", width: 120 },
                    { dataField: "name", caption: "Account Name" },
                    { dataField: "accountStartDate", caption: "Start Date", headerCellTemplate: (h, info) => { $(h).attr("title", "Sourced from Orion").append($("<span>").text(info.column.caption || "")); }, width: 100, dataType: 'date', format: 'shortDate' },
                    { dataField: "custodian", caption: "Custodian", width: 120 },
                    { dataField: "rr", caption: "RR#", width: 80 },
                    { 
                        caption: "Model", 
                        width: 120,
                        calculateCellValue: (rowData: any) => {
                            if (rowData.modelName && rowData.modelAggId) {
                                return `${rowData.modelName} - ${rowData.modelAggId}`;
                            } else if (rowData.modelName) {
                                return rowData.modelName;
                            } else if (rowData.modelAggId) {
                                return rowData.modelAggId.toString();
                            }
                            return '';
                        }
                    },
                    { dataField: "currentValue", caption: "Value", format: { type: "currency", precision: 2 }, width: 120 },
                    { dataField: "id", caption: "Action", width: 80, cellTemplate: "selectButton" }
                ]
            };
        }

        loadOrionAccounts(): void {
            if (!this.selAdvisoryFirm || !this.selAdvisoryFirm.id) {
                return;
            }

            this.loadingOrionAccounts = true;
            this.servicerService.getOrionAccSyncMonitorData(this.selAdvisoryFirm.id)
                .then(response => {
                    this.orionAccounts = response.data;
                    this.loadingOrionAccounts = false;
                }, err => {
                    this.generalService.showError(err);
                    this.loadingOrionAccounts = false;
                });
        }

        selectOrionAccount(account: any): void {
            this.selOrionAccount = account;
            this.showOrionAccountGrid = false;
            this.showOrionAccountPanel = true;
            
            // Pre-fill account data
            if (this.accountApi.paccount) {
                this.accountApi.paccount.name = account.name;
                this.accountApi.paccount.number = account.number;
                this.accountApi.pcustodianAccount.number = account.number;
            }

            // Auto-select Account Title to Individual
            if (this.titleTypes && this.titleTypes.length > 0) {
                const titleType = this.orionAccountTypeToTitleTypeMap[account.accountType];
                console.log(`Mapping Orion account type '${account.accountType}' to Title Type:`, titleType);
                if (titleType != null && titleType != undefined) {
                    const individualTitle = this.titleTypes.find(title => title.value === titleType);
                    if (individualTitle) {
                        this.selTitleType = individualTitle;
                        this.titleTypeChanged(true);
                    }
                } else {
                    console.warn(`No mapping found for Orion account type '${account.accountType}' to Title Type.`);
                    this.selTitleType = null;
                    this.titleTypeChanged(true);
                }
            }

            // Auto-select custodian dropdown based on Orion account custodian
            if (account.custodian && this.accountCreationShortcuts && this.accountCreationShortcuts.length > 0) {
                const matchingCustodian = this.accountCreationShortcuts.find(shortcut => 
                    shortcut.description && 
                    shortcut.description.toLowerCase().includes(account.custodian.toLowerCase())
                );
                
                if (matchingCustodian) {
                    this.selAccountCreationShortcut = matchingCustodian;
                    this.acShortcutChanged(true);
                }
            }

            // Notify parent component (wizard) about Orion account selection
            if (this.onOrionAccountSelected) {
                this.onOrionAccountSelected({ orionAccount: account });
            }
        }

        clearOrionAccountSelection(): void {
            this.selOrionAccount = null;
            this.showOrionAccountGrid = true;
            this.showOrionAccountPanel = false;
            
            // Notify parent component (wizard) about clearing selection
            if (this.onOrionAccountSelected) {
                this.onOrionAccountSelected({ orionAccount: null });
            }
            
            // Clear pre-filled data
            if (this.accountApi.paccount) {
                this.accountApi.paccount.name = "";
                this.accountApi.paccount.number = "";
            }
        }

        advisoryFirmChanged(changedByUserOnUI: boolean = false): void {
            //console.log(`Advisory firm changed to ${this.selAdvisoryFirm.advisoryFirmName}`);

            this.accountApi.paccount.advisoryFirm = this.selAdvisoryFirm;
            this.accountApi.paccount.advisoryFirmId = this.selAdvisoryFirm.id;

            // custodians
            this.loadCustodians(this.accountApi.paccount.advisoryFirmId)
                .then(() => {
                    if (changedByUserOnUI) {
                        this.selAccountCreationShortcut = null;
                        this.acShortcutChanged(changedByUserOnUI);
                        this.thisFormDataChanged("accountCreationShortcut", changedByUserOnUI);
                    }
                });

            this.loadTamps(this.accountApi.paccount.advisoryFirmId);
            //this.loadManagers();
            //this.loadProducts();
            this.thisFormDataChanged("advisoryFirm", changedByUserOnUI);
        }

        restrictInvestorType(): void {
            if (!this.selTitleType) {
                this.investorType = null;
                this.entityType = null;
                return;
            }
            
            if (this.selTitleType.value == domains.TitleType.TRUST) {
                this.investorType = domains.InvestorType.COMPANY;
                this.entityType = domains.EntityType.TRUST;
            }
            else {
                this.investorType = null;
                this.entityType = null;
            }
        }

        onChangeSourceAccountForAdd(): void {
            if (this.accountApi.paccount) {
                if (this.sourceAccountForAdd != null) {
                    this.accountApi.paccount.setupRelatedAccountId = this.sourceAccountForAdd.accountId;
                    this.accountApi.paccount.setupCustodianId = null;
                    this.accountApi.paccount.setupDirectAccountFlag = null;
                    // only certain type of account types are valid when using a custodian, so we limit the list
                    this.accountTypes = this.lovs.filter(v => v.lovType == domains.LovType.ACCOUNT_TYPE && !v.extra2 && (v.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS || v.value == domains.InvestmentType.MANAGED_MODELS || v.value == domains.InvestmentType.SMA || v.value == domains.InvestmentType.DIRECT_INVESTMENT));

                    // If an account type is selected, make sure the selected type is still a valid selection, if not, clear it out.
                    if (this.selAccountType) {
                        var oldSelAccountType = this.selAccountType;
                        this.selAccountType = this.accountTypes.filter(v => v.value == this.selAccountType.value)[0];
                        if (oldSelAccountType && this.selAccountType && oldSelAccountType.value != this.selAccountType.value) {
                            this.accountTypeChanged(true);
                        }
                    }

                    this.accountApi.paccount.isNewCustodianAccount = false;
                    this.accountApi.paccount.name = "";

                    this.isWorking = true;
                    this.accountApi.getById(this.accountApi.paccount.setupRelatedAccountId)
                        .then(data => {
                            var acct: domains.IAccount = data.data;
                            //console.log("LLLLLLLLLLLOADED RELATED ACCOUNT:", acct);
                            this.accountApi.paccount.name = acct.name;
                            this.accountApi.paccount.titleType = acct.titleType;
                            this.selTitleType = this.titleTypes.filter(v => v.value == acct.titleType)[0];
                            this.restrictInvestorType();

                            //console.log("TITLE TYPES ARE:", this.titleTypes);
                            //console.log("SET TITLE TYPE:", this.selTitleType);

                            this.accountApi.paccount.titleSubtype = acct.titleSubtype;
                            this.selTitleSubtype = this.titleSubtypes.filter(v => v.value == acct.titleSubtype)[0];
                            angular.copy(acct.investors, this.accountApi.paccount.investors);
                            angular.copy(acct.rtgs, this.accountApi.paccount.rtgs);
                            this.accountApi.paccount.custodianAccountId = acct.id;
                            this.thisFormDataChanged("sourceAccountAdd", true);
                        }, err => {
                            toastr.error("Account has not been loaded. Error " + err.data);
                            return false;
                        }).finally(() => {
                            this.isWorking = false
                        });
                } else {
                    this.accountApi.paccount.setupRelatedAccountId = null;
                    this.thisFormDataChanged("sourceAccountAdd", true);
                }
            }
        }

        onChangeSourceAccountForCopy(): void {
            if (this.accountApi.paccount) {
                if (this.sourceAccountForCopy != null) {
                    this.accountApi.paccount.setupRelatedAccountId = this.sourceAccountForCopy.accountId;
                    // Reset account type to null when performing a copy
                    this.selAccountType = null
                    this.accountApi.paccount.accountType = null;
                    this.isWorking = true;
                    this.advisorService.copyAccount(this.accountApi.paccount.setupRelatedAccountId).then(data => {
                        this.accountApi.paccount = data.data; // this will trigger a bind
                        // When the user is copying an existing account we are setting the account type to null
                        // so we need to keep the account information section open and highlight it as yellow.
                        //this.accountInformationComplete = false;
                        //this.accountStatusColor = this.incompleteColor;
                        if (this.impersonatedByServicer == false) {
                            toastr.success("Account has been successfully initialized. Please set the Investment Type and Continue Setup.");
                        } else {
                            toastr.success("Account has been successfully initialized. Please continue.");
                        }
                        //this.thisFormDataChanged("sourceAccountCopy", true);
                    }, err => {
                        toastr.error("Account has not been copied. Error " + err.data);
                        return false;
                    }).finally(() => {
                        this.isWorking = false
                    });
                }
            }
        }

        acShortcutChanged(changedByUserOnUI: boolean = false): void {
            if (this.selAccountCreationShortcut) {
                //console.log("Shortcut SELECTED", this.selAccountCreationShortcut);
                // Changing the shortcut restricts the InvestmentType (AccountType) that can be selected
                if (this.selAccountCreationShortcut.shortcutType == domains.AccountCreationShortcutType.CUSTODIAN) {
                    //console.log("CUSTODIAN TYPE SELECTED");
                    this.accountApi.paccount.setupCustodianId = this.selAccountCreationShortcut.shortcutId;
                    this.accountApi.paccount.setupDirectAccountFlag = null;
                    this.accountApi.paccount.isNewCustodianAccount = true;
                    // only certain type of account types are valid when using a custodian, so we limit the list
                    this.accountTypes = this.lovs.filter(v => v.lovType == domains.LovType.ACCOUNT_TYPE && !v.extra2 && (v.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS || v.value == domains.InvestmentType.MANAGED_MODELS || v.value == domains.InvestmentType.SMA || v.value == domains.InvestmentType.DIRECT_INVESTMENT));
                } else {
                    //console.log("NON-CUSTODIAN TYPE SELECTED");
                    this.accountApi.paccount.setupCustodianId = null;
                    this.accountApi.paccount.setupDirectAccountFlag = true;
                    this.accountApi.paccount.isNewCustodianAccount = false;
                    // only certain type of account types are valid when using direct, so we limit the list
                    this.accountTypes = this.lovs.filter(v => v.lovType == domains.LovType.ACCOUNT_TYPE && !v.extra2 && (v.value == domains.InvestmentType.DIRECT_INVESTMENT || v.value == domains.InvestmentType.OUTSIDE_INVESTMENT));
                }
                // If an account type is selected, make sure the selected type is still a valid selection, if not, clear it out.
                if (this.selAccountType) {
                    var oldSelAccountType = this.selAccountType;
                    this.selAccountType = this.accountTypes.filter(v => v.value == this.selAccountType.value)[0];
                    if (oldSelAccountType && this.selAccountType && oldSelAccountType.value != this.selAccountType.value) {
                        this.accountTypeChanged(changedByUserOnUI);
                    }

                    // If our shortcut is a custodian type and we are opening an account that requires a custodian then set isNewCustodianAccount on the account to true
                    //if (this.selAccountCreationShortcut.shortcutType == domains.AccountCreationShortcutType.CUSTODIAN && this.selAccountType && (this.selAccountType.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS || this.selAccountType == domains.InvestmentType.MANAGED_MODELS)) {
                    //    this.accountApi.paccount.isNewCustodianAccount = true;
                    //}
                }
            } else {
                this.accountApi.paccount.setupCustodianId = null;
                this.accountApi.paccount.setupDirectAccountFlag = null;
                //this.accountTypes = null;
                //this.selAccountType = null;
                //this.accountTypeChanged(changedByUserOnUI);
            }

            this.thisFormDataChanged("acShortcut", changedByUserOnUI);
        }

        accountNameChanged(changedByUserOnUI: boolean = false): void {
            this.thisFormDataChanged("accountName", changedByUserOnUI);
            if (this.accountApi.pcustodianAccount) {
                this.accountApi.pcustodianAccount.name = this.accountApi.paccount.name;
            }
        }

        //productTypeChanged(): void {

        //    this.showGeneralAccountTypeField = this.selProductType && (this.selProductType.value === domains.ProductType.GENERAL_INVESTMENT);
        //    this.showStateField = this.selProductType && this.selProductType.value === domains.ProductType.P_529;

        //    if (this.selProductType) {

        //        if (this.selProductType.value == domains.ProductType.GENERAL_INVESTMENT) {
        //            this.loadGeneralInvestmentAccountTypes();
        //            // default value
        //            if (!this.selGeneralInvestmentAccountType) {
        //                this.selGeneralInvestmentAccountType = this.generalInvestmentAccountTypes.filter(v => v.value == domains.GeneralInvestmentAccountType.INVESTMENT_ACCOUNT)[0];
        //                this.generalInvestmentAccountTypeChanged();
        //            }
        //        } else if (this.isInsuranceProduct() && this.accountApi.paccount.manualAccount) {
        //            this.selPremiumModel = this.premiumModels.filter(v => v.value == this.accountApi.paccount.manualAccount.premiumMode)[0];
        //            this.loadInsuranceTypes();
        //            this.selPolicyType = this.insuranceTypes.filter(v => v.value == this.accountApi.paccount.manualAccount.policyInsuranceType)[0];
        //            this.loadInsuranceSubtypes();
        //            this.selPolicySubtype = this.insuranceSubtypes.filter(v => v.value == this.accountApi.paccount.manualAccount.policyInsuranceSubtype)[0];
        //        }
        //        // reload managers and products
        //        this.loadManagers();
        //        this.loadProducts();
        //    }
        //};

        titleTypeChanged(changedByUserOnUI: boolean = false): void {

            //console.log("In titleTypeChanged, UI:", changedByUserOnUI);

            if (changedByUserOnUI && this.selTitleType) {
                this.accountApi.paccount.titleType = this.selTitleType.value;
                this.accountApi.paccount.investors = [];
                this.investorsDirty = true;
            }

            if (this.selTitleType && this.selTitleType.value >= 0) {
                this.loadTitleSubtypes();
                this.selTitleSubtype = null;
                //if (this.titleSubtypes.length > 0) {
                //    this.selTitleSubtype = this.titleSubtypes[0];
                //} else {
                //    this.selTitleSubtype = null;
                //}
            }

            this.restrictInvestorType();

            this.thisFormDataChanged("titleType", changedByUserOnUI);
        };

        titleSubtypeChanged(changedByUserOnUI: boolean = false): void {
            if (changedByUserOnUI && this.selTitleSubtype) {
                this.accountApi.paccount.titleSubtype = this.selTitleSubtype.value;
            }
            this.thisFormDataChanged("titleSubtype", changedByUserOnUI);
        };

        accountTypeChanged(changedByUserOnUI: boolean = false): void {
            //this.selTamp = null;
            // This will default TAMP to first tamp in list when managed models is selected.
            //this.hasTamp();

            //this.selProductType = null;
            //this.productTypeChanged();

            if (this.selAccountType) {
                if (this.isOutsideInvestmentAccount()) {
                    this.loadHouseholdGroups().then(
                        response => {
                            if (this.accountApi.paccount.tempHouseholdGroup > 0) {
                                let tmp = this.householdGroups.filter(v => v.id == this.accountApi.paccount.tempHouseholdGroup);
                                if (tmp && tmp.length > 0) {
                                    this.selHouseholdGroup = tmp[0];
                                }
                            }
                        }
                    );
                } else {
                    this.selHouseholdGroup = null;
                    this.accountApi.paccount.tempHouseholdGroup = null;
                }
            }

            if (changedByUserOnUI) {
                this.accountApi.paccount.accountType = this.selAccountType.value;

                // If the user switches to managed model account default the tamp to the first in the list.
                if (this.isManagedModelAccount() && this.tamps) {
                    this.selTamp = this.tamps[0];
                    this.accountApi.paccount.tampId = this.selTamp.id;
                    this.thisFormDataChanged("tamp", changedByUserOnUI);
                } else {
                    this.selTamp = null
                    this.accountApi.paccount.tampId = null;
                }

                // If our shortcut is a custodian type and we are opening an account that requires a custodian then set isNewCustodianAccount on the account to true
                // TODO: @Fehim check this - there were some changes how we compare selAccountType ...
                if (this.selAccountCreationShortcut && this.selAccountCreationShortcut.shortcutType == domains.AccountCreationShortcutType.CUSTODIAN && (this.selAccountType.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS || this.selAccountType.lovType == domains.InvestmentType.MANAGED_MODELS || this.selAccountType.lovType == domains.InvestmentType.SMA)) {
                    this.accountApi.paccount.isNewCustodianAccount = true;
                }

                // Default outside accounts to UNMANAGED, default all others to MANAGED.
                if (this.selAdvisoryFirmMgtRole == null || this.selAdvisoryFirmMgtRole == undefined) {
                    if (this.isOutsideInvestmentAccount()) {
                        this.selAdvisoryFirmMgtRole = domains.AdvisoryFirmMgtRole.UNMANAGED;
                    } else {
                        this.selAdvisoryFirmMgtRole = domains.AdvisoryFirmMgtRole.MANAGED;
                    }
                    this.advisoryFirmMgtRoleChanged(changedByUserOnUI);
                }
            }

            this.thisFormDataChanged("accountType", changedByUserOnUI);
        };

        tampChanged(changedByUserOnUI: boolean = false): void {
            if (changedByUserOnUI) {
                this.accountApi.paccount.tampId = this.selTamp.id;
            }
            this.thisFormDataChanged("tamp", changedByUserOnUI);
        }

        accountNumberChanged(changedByUserOnUI: boolean = false): void {
            this.thisFormDataChanged("tamp", changedByUserOnUI);
        }

        //managerChanged(): void {
        //    this.loadProducts();
        //}

        //productChanged(): void {
        //    if (this.accountApi.paccount.accountType === domains.InvestmentType.DIRECT_INVESTMENT) {
        //        this.loadAdvisoryFee();
        //    }
        //}

        //policyTypeChanged(): void {
        //    this.loadInsuranceSubtypes();
        //    if (this.selPolicyType) {
        //        if (this.accountApi.paccount.manualAccount)
        //            this.accountApi.paccount.manualAccount.policyInsuranceType = this.selPolicyType.value;
        //        if (this.insuranceSubtypes.length > 0) {
        //            this.hasInsuranceSubtypes = true;
        //            this.selPolicySubtype = this.insuranceSubtypes[0];
        //        }
        //        else
        //            this.selPolicySubtype = null;
        //    }
        //    else {
        //        this.selPolicySubtype = null;
        //    }
        //    this.policySubtypeChanged();
        //};

        //policySubtypeChanged(): void {
        //    if (this.accountApi.paccount.manualAccount) {
        //        if (this.selPolicySubtype)
        //            this.accountApi.paccount.manualAccount.policyInsuranceSubtype = this.selPolicySubtype.value;
        //        else
        //            this.accountApi.paccount.manualAccount.policyInsuranceSubtype = null;
        //    }
        //}

        //generalInvestmentAccountTypeChanged(): void {
        //    if (this.selGeneralInvestmentAccountType && this.accountApi.paccount.manualAccount) {
        //        this.accountApi.paccount.manualAccount.generalInvestmentAccountType = this.selGeneralInvestmentAccountType.value;
        //    }
        //    console.log("CHANGED this.accountApi.paccount.manualAccount.generalInvestmentAccountType", this.accountApi.paccount.manualAccount.generalInvestmentAccountType)
        //}

        //premiumModelChanged(): void {
        //    if (this.accountApi.paccount.manualAccount) {
        //        if (this.selPremiumModel) {
        //            this.accountApi.paccount.manualAccount.premiumMode = this.selPremiumModel.value;
        //        }
        //        else {
        //            this.accountApi.paccount.manualAccount.premiumMode = 0;
        //        }
        //    }
        //};

        householdGroupChanged(changedByUserOnUI: boolean = false): void {
            if (changedByUserOnUI) {
                if (this.selHouseholdGroup) {
                    this.accountApi.paccount.tempHouseholdGroup = this.selHouseholdGroup.id;
                } else {
                    this.accountApi.paccount.tempHouseholdGroup = null;
                }
                this.thisFormDataChanged("householdGroup", true);
            }
        }

        accountDocumentsChanged(changedByUserOnUI: boolean = false): void {
            //console.log("IN ACCOUNT DOCUMENTS CHANGED!");
            if (changedByUserOnUI) {
                this.accountApi.basicSetupDirty = true;
            }
        };

        advisoryFirmMgtRoleChanged(changedByUserOnUI: boolean = false): void {
            //console.log("IN ADV FIRM MGT ROLE CHANGED!");
            if (changedByUserOnUI) {
                this.accountApi.paccount.advisoryFirmMgtRole = this.selAdvisoryFirmMgtRole;
                this.accountApi.basicSetupDirty = true;
            }
            this.thisFormDataChanged("advisoryFirmMgtRole", changedByUserOnUI);
        };

        accountNotesChanged(changedByUserOnUI: boolean = false): void {
            //console.log("IN ACCOUNT NOTES CHANGED!");
            if (changedByUserOnUI) {
                this.accountApi.basicSetupDirty = true;
            }
        };

        // ///////////////////////////////
        // load methods
        bindAccountFromForm() {

            //console.log("Binding account from form...");

            //this.accountApi.paccount.advisoryFirm = this.selAdvisoryFirm;

            //// title type and subtype
            //if (this.selTitleType) {
            //    this.accountApi.paccount.titleType = this.selTitleType.value;
            //    this.accountApi.paccount.titleTypeDescription = this.selTitleType.name;
            //    if (this.selTitleSubtype) {
            //        this.accountApi.paccount.titleSubtype = this.selTitleSubtype.value;
            //        this.accountApi.paccount.titleSubtypeDescription = this.selTitleSubtype.name;
            //    }
            //    else {
            //        this.accountApi.paccount.titleSubtype = null;
            //        this.accountApi.paccount.titleSubtypeDescription = "";
            //    }
            //}
            //else {
            //    this.accountApi.paccount.titleType = null;
            //    this.accountApi.paccount.titleTypeDescription = "";
            //    this.accountApi.paccount.titleSubtype = null;
            //    this.accountApi.paccount.titleSubtypeDescription = "";
            //}

            //if (this.selAccountType) {
            //    this.accountApi.paccount.accountType = this.selAccountType.value;
            //}
            //else {
            //    this.accountApi.paccount.accountType = null;
            //}
            
            //if (this.selTamp && this.hasTamp()) {
            //    this.accountApi.paccount.tampId = this.selTamp.id;
            //    this.accountApi.paccount.tampType = this.selTamp.type;
            //    this.accountApi.paccount.tampName = this.selTamp.name;
            //}
            //else {
            //    this.accountApi.paccount.tampId = null;
            //}

            //if (this.selProductType && this.hasProductType()) {
            //    this.account.productTypeId = this.selProductType.value;
            //}
            //else {
            //    this.account.productTypeId = null;
            //}

            //// manager / company
            //if (this.selManager && this.hasProductType()) {
            //    this.account.managerId = this.selManager.id;
            //}
            //else {
            //    this.account.managerId = null;
            //}

            //// product
            //if (this.selProduct && this.hasProductType()) {
            //    this.account.productId = this.selProduct.id;
            //}
            //else {
            //    this.account.productId = null;
            //}

            //if (this.account.manualAccount) {
            //    if (this.selProductType && this.selProductType.value === domains.ProductType.GENERAL_INVESTMENT && this.selGeneralInvestmentAccountType) {
            //        this.account.manualAccount.generalInvestmentAccountType = this.selGeneralInvestmentAccountType.value;
            //    }
            //    else {
            //        this.account.manualAccount.generalInvestmentAccountType = null;
            //    }
            //    console.log("this.account.manualAccount.generalInvestmentAccountType", this.account.manualAccount.generalInvestmentAccountType)
            //}

        }

        bindAccountForm() {
            //console.log("Binding account form: ", this.accountApi.paccount);
            if (this.accountApi.paccount.id > 0) {

                this.doingBinding = true;

                //this.selAdvisoryFirm = <domains.IAdvisoryFirm>{ id: this.account.advisoryFirmId };
                //this.loadAdvisoryFirms().then(response => {
                //    this.selAdvisoryFirm = response.filter(v => v.id == this.accountApi.loadcustopaccount.advisoryFirmId)[0];
                //});
                this.selAdvisoryFirm = this.advisoryFirms.filter(v => v.id == this.accountApi.paccount.advisoryFirmId)[0];

                // custodians
                this.loadCustodians(this.accountApi.paccount.advisoryFirmId)
                    .then(() => this.bindAccountCreationShortcut());

                // Account setup type (new, add existing, copy existing)
                this.selSetupCode = this.accountApi.paccount.setupCreationType;
                //console.log("ACCOUNT IS: ", this.accountApi.paccount);
                //console.log("SETUP CODE IS: ", this.accountApi.paccount.setupCreationType);
                //console.log("JUST SET SETUP CODE TO", this.selSetupCode);

                if (this.accountApi.paccount.setupCreationType == this.setupCode_AddExisting && this.accountApi.paccount.setupRelatedAccountId > 0) {
                    this.accountApi.getById(this.accountApi.paccount.setupRelatedAccountId)
                        .then(data => {
                            var relAcct: domains.IAccount = data.data;
                            //console.log("RELATED ACCOUNT LOADED:", relAcct);
                            this.relAccountName = relAcct.name;
                            this.relAccountNumber = relAcct.number;
                        });
                }

                // account title and subtitle
                this.selTitleType = <domains.ILOV>{ value: this.accountApi.paccount.titleType };// this.titleTypes.filter(v => v.value == this.account.titleType)[0];
                this.restrictInvestorType();
                this.selTitleSubtype = <domains.ILOV>{ value: this.accountApi.paccount.titleSubtype };
                if (this.accountApi.paccount.accountType) {
                    this.selAccountType = <domains.ILOV>{ value: this.accountApi.paccount.accountType };//this.accountTypes.filter(v => v.value == this.account.accountType)[0];
                }

                // tamp
                this.loadTamps(this.accountApi.paccount.advisoryFirmId)
                    .then(() => {
                        if (this.accountApi.paccount.tampId && this.accountApi.paccount.tampId > 0) {
                            this.selTamp = this.tamps.filter(v => v.id == this.accountApi.paccount.tampId)[0];
                            this.thisFormDataChanged("BINDFORM", false);
                           //if (this.selTamp)
                            //    this.accountApi.paccount.tampId = this.selTamp.id;
                            //else
                            //    this.accountApi.paccount.tampId = null;
                        }
                    });

                // Managed or Unmanaged
                this.selAdvisoryFirmMgtRole = this.accountApi.paccount.advisoryFirmMgtRole;

                // HHG
                if (this.accountApi.paccount.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT) {
                    this.loadHouseholdGroups()
                        .then(() => {
                            if (this.accountApi.paccount.tempHouseholdGroup && this.accountApi.paccount.tempHouseholdGroup > 0) {
                                this.selHouseholdGroup = this.householdGroups.filter(v => v.id == this.accountApi.paccount.tempHouseholdGroup)[0];
                                this.thisFormDataChanged("BINDFORM", false);
                            }
                        });
                }

                // Document/Form Requests
                if (this.accountApi.paccount.docRequests != null && this.accountApi.paccount.docRequests.length > 0) {
                    this.accountApi.paccount.docRequests.forEach((element) => {
                        if (element.documentType == domains.DocumentType.ACH_FORM) {
                            this.selDocumentType_ACHForm = true;
                        }
                        if (element.documentType == domains.DocumentType.CHECK_INSTRUCTIONS) {
                            this.selDocumentType_CheckInstructions = true;
                        }
                        if (element.documentType == domains.DocumentType.CLIENT_AGREEMENT) {
                            this.selDocumentType_ClientAgreement = true;
                        }
                        if (element.documentType == domains.DocumentType.CLIENT_PROFILE) {
                            this.selDocumentType_ClientProfile = true;
                        }
                        if (element.documentType == domains.DocumentType.CLIENT_PLANNING_INVOICE) {
                            this.selDocumentType_PlanningInvoice = true;
                        }
                        if (element.documentType == domains.DocumentType.RISK_TOLERANCE_QUESTIONNAIRE) {
                            this.selDocumentType_RTQ = true;
                        }
                        if (element.documentType == domains.DocumentType.ASSET_TRANSFER) {
                            this.selDocumentType_TOAForm = true;
                        }
                        if (element.documentType == domains.DocumentType.WIRE_INSTRUCTIONS) {
                            this.selDocumentType_WireInstructions = true;
                        }
                        this.dateDocsNeeded = element.dateNeeded;
                        this.selDocDeliveryMethod = element.deliveryMethod;
                    });
                }

                this.thisFormDataChanged("BINDFORM", false);
                this.accountApi.basicSetupDirty = false;
                //console.log("BASIC SETUP DIRTY IS FALSE");

                // If we are loading an existing account collapse closed regions
                if (this.accountApi.paccount.id > 0) {
                    this.collapseCompleted();
                }

                var that = this;
                setTimeout(function () { that.doingBinding = false; }, 1000);
            }
        };

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {

                    this.lovs = data;

                    //this.loadInsuranceTypes();

                    //this.generalInvestmentAccountTypes = this.lovs.filter(v => v.lovType == domains.LovType.GENERAL_INVESTMENT_ACCOUNT_TYPES);

                    this.titleTypes = this.lovs.filter(v => v.lovType == domains.LovType.TITLE_TYPE);

                    this.accountTypes = this.lovs.filter(v => v.lovType == domains.LovType.ACCOUNT_TYPE && !v.extra2);

                    //this.premiumModels = this.lovs.filter(v => v.lovType == domains.LovType.PREMIUM_MODE);

                    //this.productTypes = this.lovs.filter(f => (f.lovType == domains.LovType.PRODUCT_TYPE));

                    //this.states = this.lovs.filter((value, index, array) => { return value.lovType == domains.LovType.STATES });

                    this.appInitialized = true;
                    //this.iAmReady({ ctrl: this });

                }, err => this.generalService.showError(err));
        };

        //loadInsuranceTypes(): void {
        //    if (this.selProductType) this.insuranceTypes = this.lovs.filter(v => v.lovType == domains.LovType.POLICY_INSURANCE_TYPE && v.parentId == this.selProductType.value);
        //    else this.insuranceTypes = [];
        //};

        //loadInsuranceSubtypes(): void {
        //    if (this.selPolicyType) this.insuranceSubtypes = this.lovs.filter(v => v.lovType == domains.LovType.POLICY_INSURANCE_SUBTYPE && v.parentId == this.selPolicyType.value);
        //    else this.insuranceSubtypes = [];
        //};

        //loadGeneralInvestmentAccountTypes() {
        //    this.generalInvestmentAccountTypes = this.lovs.filter(v => v.lovType == domains.LovType.GENERAL_INVESTMENT_ACCOUNT_TYPES);
        //}

        loadHouseholdGroups(): ng.IPromise<domains.IAccountGroup[]> {
            let investors = this.accountApi.paccount.investors.map(m => m.id);
            return this.advisorService.getHouseholdGroupsByInvestors(investors)
                .then(response => this.householdGroups = response.data,
                    err => console.log(`Household groups could not be loaded. Error ${err.status}: ${err.data}`));
        }

        loadAdvisoryFirms(): ng.IPromise<domains.IAdvisoryFirm[]> {
            return this.advisoryFirmApi.getAdvisoryFirms()
                .then(data => this.advisoryFirms = data.data, err => this.generalService.showError(err));
        };
        
        loadTitleSubtypes(): void {
            if (this.selTitleType) {
                this.titleSubtypes = this.lovs.filter(v => v.lovType == domains.LovType.TITLE_SUBTYPE && v.parentId == this.selTitleType.value);
            } else {
                this.titleSubtypes = [];
            }
        };

        loadTamps(advisoryFirmId: number): ng.IPromise<domains.ITamp[]> {
            //console.log("NewCuAccount loading tamps...");
            return this.advisoryFirmApi.getTamps(advisoryFirmId)
                .then(response => {
                    this.tamps = response.data;
                    // by default first TAMP is selected - PERSHING
                    //if (!this.selTamp && this.tamps.length > 0) {
                    //    this.selTamp = this.tamps[0];
                    //}
                    return response.data;
                }, err => this.generalService.showError(err));
        };

        bindAccountCreationShortcut(): void {
            // If we have an account established, set the account creation shortcut on the screen
            if (this.accountApi.paccount.setupCreationType == domains.AccountCreationType.NEW_ACCOUNT) {
                //console.log("TRYING TO AUTO-SET CREATION SHORTCUT");
                if (this.accountApi.paccount.setupDirectAccountFlag == true) {
                    this.selAccountCreationShortcut = this.accountCreationShortcuts.filter(v => v.shortcutType == domains.AccountCreationShortcutType.DIRECT)[0];
                    //console.log("11SEL AC SHORTCUT SET TO", this.selAccountCreationShortcut);
                    this.accountTypes = this.lovs.filter(v => v.lovType == domains.LovType.ACCOUNT_TYPE && !v.extra2 && (v.value == domains.InvestmentType.DIRECT_INVESTMENT || v.value == domains.InvestmentType.OUTSIDE_INVESTMENT));
                } else {
                    if (this.accountApi.paccount.setupCustodianId != null) {
                        this.selAccountCreationShortcut = this.accountCreationShortcuts.filter(v => v.shortcutType == domains.AccountCreationShortcutType.CUSTODIAN && v.shortcutId == this.accountApi.paccount.setupCustodianId)[0];
                        //console.log("22SEL AC SHORTCUT SET TO", this.selAccountCreationShortcut);
                    } else {
                        this.selAccountCreationShortcut = null;
                        //console.log("33SEL AC SHORTCUT SET TO", this.selAccountCreationShortcut);
                    }
                    this.accountTypes = this.lovs.filter(v => v.lovType == domains.LovType.ACCOUNT_TYPE && !v.extra2 && (v.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS || v.value == domains.InvestmentType.MANAGED_MODELS || v.value == domains.InvestmentType.SMA || v.value == domains.InvestmentType.DIRECT_INVESTMENT));
                }
            } else {
                this.selAccountCreationShortcut = null;
            }
            this.thisFormDataChanged("acShortcut", false);

            // If we are loading an existing account collapse closed regions
            if (this.accountApi.paccount.id > 0) {
                this.collapseCompleted();
            }
        }

        // //////////////////
        // loading methods
        loadCustodians(advisoryFirmId: number): ng.IPromise<void> {
            var that = this;
            //console.log("LOADING CUSTODIANS");
            return this.advisorService.getCustodiansForAdvisoryFirm(advisoryFirmId)
                .then(data => {
                    that.custodians = data.data;
                    //console.log("CUSTODIANS ARE:", that.custodians);
                    //this.selectCustodian();

                    // Create a new Account Creation Shortcut dropdown
                    that.accountCreationShortcuts = [];
                    that.custodians.forEach((item, index) => {
                        const acShortcut: domains.IAccountCreationShortcut = {
                            shortcutType: domains.AccountCreationShortcutType.CUSTODIAN,
                            shortcutId: item.custodian.id,
                            description: item.custodian.name
                        };
                        that.accountCreationShortcuts.push(acShortcut);
                    });
                    const acShortcut: domains.IAccountCreationShortcut = {
                        shortcutType: domains.AccountCreationShortcutType.DIRECT,
                        shortcutId: 10000,
                        description: "Other"
                    };
                    that.accountCreationShortcuts.push(acShortcut);
                }, err => this.generalService.showError(err));
        };

        //loadManagers(): ng.IPromise<any> {
        //    if (this.selProductType) {
        //        // outside investment account should show global Managers and Products for selected product type and manager
        //        if (this.accountApi.paccount.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT) {
        //            return this.advisorService.getAllManagers(this.selProductType.value)
        //                .then(response => {
        //                    this.managers = response.data;
        //                    console.log("Managers loaded", this.managers);
        //                    return response;
        //                }, err => this.generalService.showError(err));
        //        }
        //        // direct investment account should show advisory firm Managers and Products for selected product type and manager
        //        else if (this.accountApi.paccount.accountType == domains.InvestmentType.DIRECT_INVESTMENT && this.selAdvisoryFirm) {
        //            return this.advisorService.getManagers(this.selAdvisoryFirm.id, this.selProductType.value)
        //                .then(response => {
        //                    this.managers = response.data;
        //                    console.log("Managers loaded", this.managers);
        //                    return response;
        //                }, err => this.generalService.showError(err));
        //        }
        //        else {
        //            console.log("Missing account type or advisory firm!", this.selAdvisoryFirm, this.accountApi.paccount.accountType);
        //        }
        //    }
        //    else
        //        console.log("Missing product type!");

        //    // else reset manager list
        //    this.selManager = null;
        //    this.managers = [];
        //};

        //loadProducts(): ng.IPromise<any> {
        //    if (this.selManager && this.selProductType) {
        //        // outside investment account should show global Managers and Products for selected product type and manager
        //        if (this.accountApi.paccount.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT) {
        //            return this.advisorService.getProductsByManager(this.selProductType.value, this.selManager.id)
        //                .then(response => {
        //                    this.products = response.data;
        //                    //console.log("Products loaded", this.products);
        //                }, err => this.generalService.showError(err));
        //        }
        //        // direct investment account should show advisory firm Managers and Products for selected product type and manager
        //        else if (this.accountApi.paccount.accountType == domains.InvestmentType.DIRECT_INVESTMENT && this.selAdvisoryFirm) {
        //            return this.advisorService
        //                .getProductsByFirm(this.selAdvisoryFirm.id, this.selProductType.value, this.selManager.id, domains.InvestmentType.DIRECT_INVESTMENT)
        //                .then(response => {
        //                    this.products = response.data;
        //                    //console.log("Products loaded", this.products);
        //                }, err => this.generalService.showError(err));
        //        }
        //    }

        //    // else reset product list
        //    this.selProduct = null;
        //    this.products = [];
        //};

        //loadAdvisoryFee() {
        //    let feeOnProduct = false;

        //    // take fee from product
        //    if (this.selProduct && this.products.length > 0) {
        //        this.products.filter(product => product.id === this.selProduct.id)[0].firmProducts.forEach(firmProduct => {
        //            if (firmProduct.advisoryFee) {
        //                this.accountApi.paccount.advisoryFee = firmProduct.advisoryFee;
        //                feeOnProduct = true;
        //                return;
        //            }
        //        });
        //    }

        //    //take default advisoryFirm fee
        //    if (!feeOnProduct && this.selAdvisoryFirm) {
        //        this.advisoryFirms.forEach(firm => {
        //            if (firm.id === this.selAdvisoryFirm.id) {
        //                this.accountApi.paccount.advisoryFee = firm.defaultAdvisoryFee;
        //                return;
        //            }
        //        });
        //    }
        //}

        firstInvestorAdded: boolean = false;
        // ///////////////////////////////////////
        // events from other components handling
        newInvestorSelected(investor: domains.IInvestor): void {
            var inv = this.accountApi.paccount.investors.filter(v => v.id == investor.id);
            if (inv.length === 0) {

                if (!this.selTitleType) {
                    toastr.warning("Please select account type.");
                    return;
                }

                // We will enable this check later when we are able to incorporate trustee data
                // and all trusts exist in Salesforce
                //if (this.selTitleType.value == domains.TitleType.TRUST.valueOf()) {
                //    if (investor.entityType != domains.EntityType.TRUST.valueOf()) {
                //        toastr.warning("Only Trust entities can be investors on Trust accounts.");
                //        return;
                //    }
                //}

                if (this.isMultiInvestorAccount()) {
                    this.addInvestorToInvestors(investor);
                    return;
                }

                if (this.isCustodialAccount()) {
                    this.addInvestorToInvestors(investor);
                    return;
                }

                if (this.isOtherAccount()) {
                    this.addInvestorToInvestors(investor);
                    return;
                }

                if (!this.isMultiInvestorAccount(true) && !this.isCustodialAccount(true) && !this.isOtherAccount(true)) {
                    if (this.accountApi.paccount.investors.length < 1) {
                        this.addInvestorToInvestors(investor);
                        return;
                    }
                    else {
                        toastr.warning("Cannot add more than one investor for this title type.");
                        return;
                    }
                }
                else {
                    return;
                }
            }
            else
                toastr.warning("Investor already exists on the list of investors for this account.");
        };

        changedMinorInvestor(investor: domains.IInvestor): void {
            for (let i = 0; i < this.accountApi.paccount.investors.length; i++)
                this.accountApi.paccount.investors[i].minorInvestor = false;

            var index = this.accountApi.paccount.investors.indexOf(investor);

            let inv = this.accountApi.paccount.investors[index];

            inv.minorInvestor = true;
        }

        changedPrimaryInvestor(investor: domains.IInvestor): void {
            for (let i = 0; i < this.accountApi.paccount.investors.length; i++)
                this.accountApi.paccount.investors[i].primaryInvestor = false;
                
            var index = this.accountApi.paccount.investors.indexOf(investor);

            let inv = this.accountApi.paccount.investors[index];
            
            inv.primaryInvestor = true;
        }

        //printInvestors(): void {
        //    for (let i = 0; i < this.account.investors.length; i++) {
        //        console.log("Investor: " + i + " ", this.account.investors[i]);
        //    }
        //}

        addInvestorToInvestors(investor: domains.IInvestor): void {
            if (this.accountApi.paccount.investors.length == 0 && this.isMultiInvestorAccount(true))
                investor.primaryInvestor = true;

            if (this.accountApi.paccount.investors.length == 1 && this.isCustodialAccount(true))
                investor.minorInvestor = true;

            this.accountApi.paccount.investors.push(investor);
            this.firstInvestorAdded = true;
            this.loadHouseholdGroups();
            this.investorsDirty = true;
            this.thisFormDataChanged("investorList", true);
        }

        isMultiInvestorAccount(flag: boolean = false): boolean {
            if (!flag) {
                if (this.selTitleType.value == domains.TitleType.JOINT_TENANT.valueOf()
                    || this.selTitleType.value == domains.TitleType.JOINT_TRANSFER_ON_DEATH.valueOf()
                    || this.selTitleType.value == domains.TitleType.TRUST.valueOf()
                    || this.selTitleType.value == domains.TitleType.ESTATE.valueOf()) {

                    if (this.accountApi.paccount.investors.length == 6) {
                        toastr.warning("The maximum number of investors for this title type is six.");
                        return false;
                    }
                    else {
                        //toastr.warning("Please add at least two investors for this title type.");
                        return true;
                    }
                }
                else {
                    return false;
                }
            } else {
                if (this.selTitleType.value == domains.TitleType.JOINT_TENANT.valueOf() || this.selTitleType.value == domains.TitleType.JOINT_TRANSFER_ON_DEATH.valueOf())
                    return true;
                return false;
            }
        }

        checkOutsideAccountHH(): boolean {
            if (this.accountApi.paccount.accountType != domains.InvestmentType.OUTSIDE_INVESTMENT) {
                return true;
            } else {
                if (!this.selHouseholdGroup) {
                    return false;
                } else {
                    return true;
                }
            }
        }

        checkCustodialAcctInvestors(): boolean {
            if (this.selTitleType == null) {
                return false;
            }
            else if (this.selTitleType.value === domains.TitleType.CUSTODIAL && this.accountApi.paccount.investors.length < 2) {
                return false;
            }
            return true;
        }

        checkJointAcctInvestors(): boolean {
            if (this.selTitleType == null) {
                return false;
            }
            if ((this.selTitleType.value == domains.TitleType.JOINT_TENANT.valueOf()
                || this.selTitleType.value == domains.TitleType.JOINT_TRANSFER_ON_DEATH.valueOf())
                && this.accountApi.paccount.investors && this.accountApi.paccount.investors.length < 2) {
                return false;
            }
            return true;
        }

        isCustodialAccount(flag: boolean = false): boolean {
            if (!flag) {
                if (this.selTitleType.value === domains.TitleType.CUSTODIAL) {
                    if (this.accountApi.paccount.investors.length < 2) {
                        return true;
                    }
                    else {
                        toastr.warning("Cannot add more then two investors for this title type.");
                        return false;
                    }
                }
                else {
                    return false;
                }
            } else {
                if (this.selTitleType.value === domains.TitleType.CUSTODIAL)
                    return true;
                return false;
            }
        }

        isOtherAccount(flag: boolean = false): boolean {
            if (!flag) {
                if (this.selTitleType.value === domains.TitleType.OTHER) {
                    if (this.accountApi.paccount.investors.length < 2) {
                        return true;
                    }
                    else {
                        toastr.warning("Cannot add more than two investors for this title type.");
                        return false;
                    }
                }
                else {
                    return false;
                }
            } else {
                if (this.selTitleType.value === domains.TitleType.OTHER)
                    return true;
                return false;
            }
        }


        // ///////////////////////////////////
        // dynamic properties
        showTempHH(): boolean {
            //return (this.isOutsideInvestmentAccount() || (this.isDirectInvestmentAccount() && this.isInsuranceProduct()));
            return (this.isOutsideInvestmentAccount() || this.isDirectInvestmentAccount());
        };

        hasProposal(): boolean {
            // proposal is used for Managed Investments and Individual Holdings
            return (
                (this.accountApi.paccount.id > 0 &&
                    (this.accountApi.paccount.accountType == domains.InvestmentType.MANAGED_MODELS
                    || this.accountApi.paccount.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS
                    || this.accountApi.paccount.accountType == domains.InvestmentType.SMA))
                ||
                (this.selAccountType &&
                    (this.selAccountType.value == domains.InvestmentType.MANAGED_MODELS
                        || this.selAccountType.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS
                        || this.selAccountType.value == domains.InvestmentType.SMA)));
        }

        hasSubscriptionAgreement(): boolean {
            // subscription document is used for Direct Investments
            var ret = (
                (this.accountApi.paccount && (this.accountApi.paccount.id > 0) && (this.accountApi.paccount.accountType == domains.InvestmentType.DIRECT_INVESTMENT))
                ||
                (this.selAccountType && (this.selAccountType.value == domains.InvestmentType.DIRECT_INVESTMENT))
            );
            return ret;
        }

        //hasCustodian(): boolean {
        //    return this.selAccountType &&
        //        (this.selAccountType.value == domains.InvestmentType.MANAGED_MODELS
        //            || this.selAccountType.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS);
        //}

        //isCustodianOptional(): boolean {
        //    return this.selAccountType && this.selProductType
        //        && this.selAccountType.value == domains.InvestmentType.DIRECT_INVESTMENT
        //        && (this.selProductType.value == domains.ProductType.GENERAL_INVESTMENT
        //            || (this.selProductType.value == domains.ProductType.REIT
        //                // 
        //                // && this.selTitleType 
        //                // && (this.selTitleType.value == domains.TitleType.IRA || this.selTitleType.value == domains.TitleType.OTHER_RETIREMENT)
        //            )
        //        );
        //}

        //isCustodianRequired(): boolean {

        //    return (
        //            (this.selAccountType &&
        //                (this.selAccountType.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS ||
        //                    this.selAccountType.value == domains.InvestmentType.MANAGED_MODELS)
        //            ) ||
        //        (this.selAccountType && this.selProductType
        //            && this.selAccountType.value == domains.InvestmentType.DIRECT_INVESTMENT
        //            && this.selProductType.value == domains.ProductType.REIT
        //            && this.selTitleType
        //            && (this.selTitleType.value == domains.TitleType.IRA || this.selTitleType.value == domains.TitleType.OTHER_RETIREMENT)
        //        )
        //    );
        //}

        hasTamp(): boolean {
            let v = this.selAccountType &&
                (this.selAccountType.value == domains.InvestmentType.MANAGED_MODELS || this.selAccountType.value == domains.InvestmentType.SMA);

            //if (v && !this.selTamp && this.tamps && this.tamps.length > 0)
            //    this.selTamp = this.tamps[0];

            return v;
        };

        hasProductType(): boolean {
            return this.selAccountType &&
                (this.selAccountType.value == domains.InvestmentType.DIRECT_INVESTMENT || this.selAccountType.value == domains.InvestmentType.OUTSIDE_INVESTMENT);
        };

        isOutsideInvestmentAccount(): boolean {
            return (this.selAccountType && this.selAccountType.value == domains.InvestmentType.OUTSIDE_INVESTMENT);
        }

        isDirectInvestmentAccount(): boolean {
            return (this.selAccountType && this.selAccountType.value == domains.InvestmentType.DIRECT_INVESTMENT);
        }

        isManagedModelAccount(): boolean {
            return (this.selAccountType && this.selAccountType.value == domains.InvestmentType.MANAGED_MODELS);
        }

        //isInsuranceProduct(): boolean {
        //    return this.selProductType && (this.selProductType.value === domains.ProductType.LIFE_INSURANCE ||
        //        this.selProductType.value === domains.ProductType.OTHER_INSURANCE);
        //}
        //isAnnuityProduct(): boolean {
        //    return this.selProductType && (this.selProductType.value === domains.ProductType.ANNUITY);
        //}
        //isOtherProduct(): boolean {
        //    return this.selProductType
        //        && (this.selProductType.value !== domains.ProductType.ANNUITY)
        //        && (this.selProductType.value !== domains.ProductType.LIFE_INSURANCE)
        //        && (this.selProductType.value !== domains.ProductType.OTHER_INSURANCE);
        //}

        isBrokerDealerFirm(): boolean {
            return this.selAdvisoryFirm.firmType == domains.FirmType.BROKER_DEALER;
        }
        
        // overrides ...
        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.impersonatedByServicer = (this.user.impersonatedByRole == "SERVICER" || this.user.impersonatedByRole == "SERVICER_LEAD" || this.user.impersonatedByRole == "SERVICER_ADMIN")
                //this.currentAdvisor = response.advisor;
                this.companyGroup = response.advisor.companyGroup;
                // console.log(`NewCuAccount: onInit fired ${JSON.stringify(this.companyGroup) }`);
            });
        };
        $onChanges(event): void {
            //console.log("CuAccount: onChanges fired", event, this.advisoryFirm);
            //console.log("Acount on changes: ", this.account);
            for (var key in event) {
                //if (key === "advisoryFirm") {
                //   // console.log(`Binding advisory firm`, this.advisoryFirm);
                //    if (this.advisoryFirm) {
                //        this.accountApi.paccount.advisoryFirm = this.advisoryFirm;
                //        this.accountApi.paccount.advisoryFirmId = this.advisoryFirm.id;
                //        this.selAdvisoryFirm = this.advisoryFirm;
                //        this.loadTamps(this.advisoryFirm.id);
                //    }
                //}
            }
        }

    }

    class NewCuAccount implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                //account: "=",
                iAmReady: "&",
                formDataChanged: "&",
                onOrionAccountSelected: "&",
                //advisorIsDone: "&",
                //advisoryFirm: "<"
            };
            this.controller = NewCuAccountController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/new-cu-account.html";
        }
    }
    angular.module(Constants.APP).component("newCuAccount", new NewCuAccount());
}